import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import * as moment from 'moment';
import { AmChartsService, AmChart } from '@amcharts/amcharts3-angular';
import { EmployeeService } from 'src/app/Services/employee.service';
import { interval } from 'rxjs';
import { CommonService } from 'src/app/Services/common.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public show1: boolean = true;
  public show2: boolean = false;
  public show3: boolean = false;
  private chart: AmChart;

  constructor(public AmCharts: AmChartsService, 
              public _employeeService: EmployeeService,
              public _CommonService: CommonService) {
  }

  ngOnInit() {
    this.getProgrammersList();
    this._CommonService.displayKeyExpiryCount();
  }

  workingDetail() {
    this.show1 = true;
    this.show2 = false;
    this.show3 = false;
  }

  pendingDetail() {
    this.show1 = false;
    this.show2 = true;
    this.show3 = false;
  }

  deliveryDetail() {
    this.show1 = false;
    this.show2 = false;
    this.show3 = true;
  }

  getProgrammersList() {
      this._employeeService.Fetch_Employee('ADMINPRMS').subscribe(data => {
      this._employeeService.allEmployees = data;
    })
  }

  checkDate(date): boolean {
    date = new Date(date)
    return !(moment(date.toLocaleDateString()).isSame(new Date().toLocaleDateString()))
  }
}
